import { Paper, Stack } from "@mui/material";
import type { FC } from "react";

import type { ContentTone } from "../brand-kit/server/brand-kit-service";
import { CommsTemplateContent } from "./comms-template-content";
import { CommsTemplateImages } from "./comms-template-images";

interface CommsTemplatePreviewProps {
  contentTone: ContentTone | "custom";
  onContentToneChange: (value: ContentTone | "custom") => void;
}

export const CommsTemplatePreview: FC<CommsTemplatePreviewProps> = ({
  contentTone,
  onContentToneChange,
}) => {
  return (
    <Stack direction="column" gap={2} mt={2}>
      <CommsTemplateImages mb={2} />
      <Paper
        elevation={1}
        sx={(theme) => ({
          px: 2,
          bgcolor: theme.palette.background.paper,
        })}
      >
        <CommsTemplateContent contentTone={contentTone} onContentToneChange={onContentToneChange} />
      </Paper>
    </Stack>
  );
};
